import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {useMenuGrpList} from "../../../static/js/hock/menuHock";

import menuGrpBtn from '../../../static/image/v2/menu/menuGrpBtn.png';
import mark from '../../../static/image/19mark.png'
import {formatCost, handleImgError, openPopup, setChecked, setValue} from "../../../static/js/Common2";
import {menuStatusFormat} from "../../../static/js/service/formatService";
import {
  getMenuDetail, getMenuDetail2, getMenuImage,
  menuGrpDetail,
  menuGrpStatusChange,
  menuStatusChange
} from "../../../static/js/service/menuService";
import MenuGrpPopupV2 from "./MenuGrpPopupV2";
import MenuListPopupV2 from "./MenuListPopupV2";
import {useShopAdminDetail2, useShopCategory, useShopInfo} from "../../../static/js/hock/shopHock";
import imgRemoveBtn from "../../../static/image/v2/imgRemoveBtn.png";
import axios from "axios";
import {subNavEvent} from "../../../static/js/service/commonService";
import "../../../static/css/menu.css";
import { ORDER_API } from "constants/apiUrls";
import MenuImageSearchPopup from "../../popup/MenuImageSearchPopup";
import MenuImageSearchPopup2 from "../../popup/MenuImageSearchPopup2";

export default function MenuListV2Test() {
  const [shopList, setShopList] = useState([]);
  const [shopId, setShopId] = useState();
  const [serviceType, setServiceType] = useState(1);
  const [list, setList] = useState([]);
  const [category, setCategory] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [reset, setReset] = useState(false);
  const [bestMenuList, setBestMenuList] = useState([]);

  useMenuGrpList({setList, setOptionList}, shopId);
  useShopInfo({setServiceType}, shopId);
  useShopCategory({setCategory}, shopId);

  useEffect(() => {
    function handleClickOutside(e) {
      let menuSelect = document.querySelectorAll(`.menuSelect`);
      menuSelect.forEach((element) => {
        element.classList.remove("active");
      })

      if(e.target.classList.contains("menuSelectText")) {
        let dataId = e.target.getAttribute("data-id");
        let menuSelect2 = document.querySelector(`#menuBox${dataId} .menuSelect`);
        menuSelect2.classList.add("active");
      }
    }

    // document에 클릭 이벤트 리스너 추가
    document.addEventListener('click', handleClickOutside);

    const targetId = sessionStorage.getItem("targetId");

    if(targetId) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        sessionStorage.removeItem("targetId");
      }
    }

    subNavEvent("menuNav", "menu1");

    if (list.length > 0) {
      let bestMenuDataList = [];
      list.forEach((group) => {
        if (group.menuList?.length > 0) {
          group.menuList.forEach((menu) => {
            if (menu.isMainMenu) {
              bestMenuDataList.push({
                id: menu.id,
                name: menu.name,
                mainMenuVisibleIndex: menu.mainMenuVisibleIndex || 1
              })
            }
          })
        }
      });

      setBestMenuList(bestMenuDataList);
    }
  }, [list]);

  let menuGrpBox = list.map(({id, name, desc, isVisible, menuList}) => {
    let menuGrpId = id;
    return (
      <div id={`menuListBox${id}`} className="menuListBox" key={id}>
        <div className="menuGrpBox">
          {/* 그룹 정보 */}
          <div className="textBox" onClick={() => menuGrpDetailEvent(id)}>
            <h3 className="menuGrpName">{name}</h3>
            <p className="menuGrpDesc">{desc}</p>
          </div>
          {/* 그룹 토글 및 버튼 */}
          <div className={`menuToggle ${isVisible ? "active" : ""}`} >
            <label className="toggleSwitch" onClick={(e) => menuGrpStatusEvent(e, id)}>
              <input type="checkbox" className="toggleInput" defaultChecked={isVisible} hidden />
              <span className="toggleBtn"></span>
            </label>
            <span className={`toggleStates ${!isVisible ? "gray" : ""}`}>
              {isVisible ? "전체 노출" : "미노출"}
            </span>
          </div>
          <div className="menuGrpBtn">
            <button>
              <img
                src={ menuGrpBtn } alt="숨김버튼"
                onClick={(e) => menuGrpToggleBtnEvent(e, id)}
              />
            </button>
          </div>
        </div>
        {/* 하위 메뉴 리스트 */}
        <div className="menuInfoBox">
          {menuList.map(({id, imageUrl, name, status, isMainMenu, isAdultMenu, menuCostList, optionGroupList}) => {
            // 가격 및 옵션 정보 변경
            let productCostText = '';
            let optionText = "";

            if (menuCostList.length !== 0) {
              productCostText = menuCostList.map(({ name, cost }) => {
                return `${name !== '' ? name + ' - ' : ''}${formatCost(cost)}원`;
              }).join(', ');
            }
            if (optionGroupList.length !== 0) {
              optionText = optionGroupList.map(({name}) => {return name}).join(', ');
            }

            let statusText = "";
            if(status === 2) {
              statusText = " (판매 중지)"
            } else if(status === 3) {
              statusText = " (품절)"
            }

            return (
              <div id={`menuBox${id}`} className="menuBox" key={id}>
                {/* 메뉴 이미지 미리보기 */}
                <div className="preview">
                  <img
                    src={imageUrl} alt={name}
                    onError={(e) => handleImgError(e)}
                  />
                </div>
                {/* 메뉴 정보 */}
                <div className="pointer" onClick={() => menuDetailEvent(id)}>
                  <div>
                    <h3 className={`menuName ${status === 1 ? "" : "stop"}`}>
                      {isMainMenu &&
                        <span className="blue">대표 </span>
                      }
                      {isAdultMenu &&
                        <img className="adult" src={mark} alt="19세 제한" />
                      }
                      {name}
                      <span className="statusText">{statusText}</span>
                    </h3>
                    <ul className="menuPrice">
                      <li>
                        <span>메뉴가격</span>
                        <p>{productCostText}</p>
                      </li>
                      {optionGroupList.length > 0 &&
                        <li>
                          <span>옵션그룹</span>
                          <p>{optionText}</p>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                {/* 메뉴 상태 셀렉트 */}
                <div className="menuSelect">
                  <div className={`menuSelectText ${status === 1 ? "" : "red"}`} data-id={id}>
                    {menuStatusFormat(status)}
                  </div>
                  <ul className="menuSelectOptionList">
                    <li onClick={() => menuStatusChangeEvent(menuGrpId, id, 1)}>판매</li>
                    <li className="red" onClick={() => menuStatusChangeEvent(menuGrpId, id, 2)}>판매중지</li>
                    <li className="red" onClick={() => menuStatusChangeEvent(menuGrpId, id, 3)}>품절</li>
                  </ul>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  })

  // 메뉴 그룹 상태 변경 이벤트
  const menuGrpStatusEvent = (e, id) => {
    if (!menuGrpStatusEvent.isRunning) {
      menuGrpStatusEvent.isRunning = true;

      let isChecked = e.currentTarget.querySelector(".toggleInput").checked;
      menuGrpStatusChange(shopId, id, isChecked);

      setTimeout(() => {
        menuGrpStatusEvent.isRunning = false;
      }, 1000); // 중복 실행 방지를 위한 시간 설정 (1초)
    }
  }

  // 메뉴 그룹 토글 버튼 이벤트
  const menuGrpToggleBtnEvent = (e, id) => {
    let menuListBox = document.getElementById(`menuListBox${id}`);

    if(e.target.classList.contains("active")) {
      menuListBox.querySelector(".menuInfoBox").classList.remove("hide");
      e.target.classList.remove("active");
    } else {
      menuListBox.querySelector(".menuInfoBox").classList.add("hide");
      e.target.classList.add("active");
    }
  }

  // 메뉴 상태 변경 이벤트
  const menuStatusChangeEvent = (menuGrpId, menuId, status) => {
    menuStatusChange(shopId, menuGrpId, menuId, status).then(() => {
      let menuNameClass = document.querySelector(`#menuBox${menuId} .menuName`);
      let menuSelectText = document.querySelector(`#menuBox${menuId} .menuSelectText`);
      let statusText = document.querySelector(`#menuBox${menuId} .statusText`);

      menuSelectText.innerText = menuStatusFormat(status);
      if(status === 1) {
        menuNameClass.classList.remove("stop");
        menuSelectText.classList.remove("red");
        statusText.innerText = "";
      } else if(status === 2) {
        menuNameClass.classList.add("stop");
        menuSelectText.classList.add("red");
        statusText.innerText = " (판매 중지)";
      } else if(status === 3) {
        menuNameClass.classList.add("stop");
        menuSelectText.classList.add("red");
        statusText.innerText = " (품절)";
      }
    })
  }

  // 메뉴 그룹 상세
  const menuGrpDetailEvent = async (id) => {
    let menuGrpData = await menuGrpDetail(shopId, id);

    document.getElementById("modiMenuGrpId").value = id;
    document.getElementById("modiMenuGrpNameInput").value = menuGrpData.name;
    document.getElementById("modiMenuGrpDesc").value = menuGrpData.desc;
    document.getElementById("modiMenuGrpStates").checked = menuGrpData.isVisible;

    openPopup("modiMenuGrpPopup");
  }

  // 메뉴 상세
  const menuDetailEvent = async (id) => {
    let menuData = await getMenuDetail(id);
    let menuData2 = await getMenuDetail2(id);
    let menuDetailImageData = await getMenuImage(id, 10);

    console.log(menuData)

    list.forEach(({id, name}) => {
      if(id === menuData.menuGroupId) {
        document.querySelector('#menuGrpSelect2 .selectText').setAttribute("data-id", id);
        document.querySelector('#menuGrpSelect2 .selectText').innerText = name;
      }
    })

    setValue("menuId2", id);
    setValue("menuName2", menuData.name)
    setChecked("bestMenu2", menuData.isMainMenu);
    setChecked("adultMenu2", menuData.isAdultMenu);
    setValue("modiMenuCount", menuData.remainCount);
    setValue("menuDesc2", menuData.desc);
    setValue("menuInfo2", menuData.struct);

    const bestMenuBtn2 = document.getElementById("bestMenuBtn2");

    if (menuData.isMainMenu) {
      bestMenuBtn2.classList.remove("d-none");
    } else {
      bestMenuBtn2.classList.add("d-none");
    }

    let menuStatesRadio = document.querySelectorAll(".menuStatesRadio2");
    menuStatesRadio.forEach((element) => {
      element.checked = false;
    });
    let menuStatesBtn = document.querySelectorAll(".menuStatesBtn2");
    menuStatesBtn.forEach((element) => {
      element.classList.remove("active");
    });

    setChecked(`menuStates2${menuData.status}`, true);
    document.querySelector(`.menuStatesBtn2${menuData.status}`).classList.add("active");

    const menuCostList = menuData.menuCostList;
    const menuPriceList2 = document.getElementById("menuPriceList2");

    if(menuCostList.length > 0) {
      const addMenuPrice = menuPriceList2.querySelectorAll(".addMenuPrice");
      addMenuPrice.forEach((element) => {
        element.remove();
      })

      menuCostList.forEach(({id, name, cost, saleCost}, index) => {
        if(index === 0) {
          document.querySelector(".menuPriceBox2").setAttribute("data-id", id);
          document.querySelector(".menuPriceBox2").setAttribute("data-number", index);
          setValue("menuPriceName2", name);
          setValue("menuPrice2", cost);
          setValue("menuSalePrice2", saleCost);
        } else {
          let div = document.createElement("div");
          div.innerHTML = `<input type='text' class='menuPriceName' name='menuPriceName' value="${name}" placeholder='가격명' />` +
            `<input type='number' class='menuPrice number' name='menuPrice' value="${cost}" placeholder='가격 입력(숫자만)' />` +
            `<input type='number' class="menuSalePrice number width134 ${serviceType === 6 ? "" : "hide"}" name='menuSalePrice' value="${saleCost}" placeholder='할인 가격(숫자만)' />` +
            `<button type='button' class='menuPriceRemoveBtn'>삭제</button>`

          div.setAttribute('class', `menuPriceBox addMenuPrice addMenuPrice2`)
          div.setAttribute("data-id", id);
          div.setAttribute("data-number", index);
          div.setAttribute("data-modi", 1);

          menuPriceList2.appendChild(div);

          div.lastChild.addEventListener('click', () => {
            div.classList.add("hide");
          });

          div.querySelectorAll(".number").forEach((element) => {
            element.addEventListener("change", (e) => {
              let n = e.target.value;

              if(n < 0) {
                alert('0원 이상 입력가능합니다.');
                e.target.value = 0;
              } else if(n === '') {
                e.target.value = '';
              }
            });
          });
        }
      });
    }

    const optionGroupList = menuData.optionGroupList;
    const menuOptionList2 = document.getElementById("menuOptionList2");

    if(optionGroupList.length > 0) {
      const addMenuOption = menuOptionList2.querySelectorAll(".optionNameBox");
      addMenuOption.forEach((element) => {
        element.remove();
      });

      optionGroupList.forEach(({name}) => {
        optionList.forEach((value) => {
          if(value.name === name) {
            const div = document.createElement("div");
            div.innerHTML = `<input type='text' class='optionName' value='${ name }' name='optionName' readOnly />` +
                            `<button type='button' class='menuPriceRemoveBtn'>삭제</button>`;

            div.setAttribute('class', 'optionNameBox modiOptionNameBox addOptionNameBox');
            div.setAttribute('data-id', value.id);
            menuOptionList2.appendChild(div);

            div.lastChild.addEventListener('click', () => {
              div.classList.add("hide");
            });
          }
        })
      })
    }

    if(category.length > 0) {
      if(menuData2.categoryId === 1) {
        document.querySelector('#categorySelect2 .selectText').setAttribute("data-id", category[0].id);
        document.querySelector('#categorySelect2 .selectText').innerText = category[0].name;
      } else {
        category.forEach(({id, name}) => {
          if(id === menuData2.categoryId) {
            document.querySelector('#categorySelect2 .selectText').setAttribute("data-id", id);
            document.querySelector('#categorySelect2 .selectText').innerText = name;
          }
        })
      }
    }

    if(menuData.imageList?.length > 0) {
      document.querySelector("#menuImgPreview2 .menuImg").setAttribute("src", menuData.imageList[0].imageUrl);
      document.querySelector("#menuImgPreview2 .imgBtn").classList.add("hide");
      document.querySelector("#menuImgPreview2 .imageSearchBtn").classList.add("hide");
      document.querySelector("#menuImgPreview2 .menuImgPreview").classList.remove("hide");
      document.querySelector("#menuImgPreview2 .menuImgFile").setAttribute("data-id", menuData.imageList[0].id)
    } else {
      setValue("menuImgFile2", "");
      document.querySelector("#menuImgPreview2 .menuImg").setAttribute("src", "");
      document.querySelector("#menuImgPreview2 .imgBtn").classList.remove("hide");
      document.querySelector("#menuImgPreview2 .imageSearchBtn").classList.remove("hide");
      document.querySelector("#menuImgPreview2 .menuImgPreview").classList.add("hide");
      document.querySelector("#menuImgPreview2 .menuImgFile").setAttribute("data-id", 0)
    }

    if(serviceType === 6) {
      let detailImgBox2 = document.querySelector(".detailImgBox2");
      let shopDetailImgBox2 = document.querySelector(".shopDetailImgBox2");

      detailImgBox2.innerHTML = "";
      shopDetailImgBox2.innerHTML = "";

      menuDetailImageData.forEach(({id, filePath}) => {
        const li = document.createElement("li");
        li.innerHTML =  `<img src=${filePath} alt="상세" />` +
                        `<button class='removeBtn' data-id=${id}><img src=${imgRemoveBtn} alt='삭제버튼' /></button>`;

        li.setAttribute('class', `detailPreview`);
        li.setAttribute('data-id', id);
        li.setAttribute('data-modi', "1");

        let img = document.createElement('img');
        img.setAttribute('src', filePath);

        detailImgBox2.appendChild(li);
        shopDetailImgBox2.appendChild(img);

        let removeBtn = li.querySelector(".removeBtn");
        removeBtn.addEventListener("click", () => {
          li.classList.add("hide");
          img.remove();
        })
      });

      let menuInfoList = await axios.get(`${ORDER_API}/menu/v2/detail/mall/${id}`).catch((e) => {
        console.log(e);
      });

      if(menuInfoList) {
        if(menuInfoList.data.menuInfoList.length > 0) {
          menuInfoList.data.menuInfoList.forEach((value) => {
            let div = document.createElement('div')
            div.innerHTML = `<p class='menuInfoTitle'>${ value.title }</p>` +
              `<input type='text' class='menuInfoInput' value="${ value.desc }" maxlength='100' />`;
            div.setAttribute('class', 'menuInfoInputBox')
            document.querySelector(".menuInfoList2").appendChild(div);
          })
        }
      }
    }

    openPopup("modifyMenuPopup");
  }


  return (
    <main id="menuListV2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <MenuGrpPopupV2 shopId={shopId} list={list} reset={reset} setReset={setReset} />
      <MenuListPopupV2 shopId={shopId} list={list} reset={reset} setReset={setReset} category={category} optionList={optionList} serviceType={serviceType} bestMenuList={bestMenuList} />

      <div className="container">
        <section className="containerInner">
          <PageNameV2 title1="메뉴 관리" title2="메뉴/그룹 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="메뉴/그룹 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/menuList" setShopId={setShopId} setShopList={setShopList} />
            </div>
            <div className="menuListBtn">
              <button className="commonBtn blueBtn openBtn" onClick={() => openPopup("newMenuPopup")}>메뉴 추가</button>
              <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => {
                openPopup("menuPopup3");
                setReset(true);
              }}>메뉴 순서변경</button>
              <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => {openPopup("menuGrpPopup1")}}>그룹 추가</button>
              <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => {
                openPopup("menuGrpPopup2");
                setReset(true);
              }}>그룹 순서변경</button>
              <button className="commonBtn blueBtn openBtn marginLeft5" onClick={() => {openPopup("menuRemovePopup1")}}>그룹/메뉴 삭제</button>
            </div>
          </div>
          {menuGrpBox}
        </section>
      </div>
    </main>
  )
}